import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Typography } from '../../../components';
import styles from './OfflinePSD2Verified.module.scss';

export default function OfflinePSD2Verified() {
  const { t } = useTranslation(['offline_psd', 'psd2_verified']);
  const searchParams = new URLSearchParams(window.location.search);
  // NOTE: possible options should be [DONE, ERROR, NAME_SURNAME_MISMATCH]
  const resultStatus = searchParams.get('status') || '';

  const psdResultMessageKey =
    resultStatus === 'DONE' ? 'result.DONE' : 'result.ERROR';

  return (
    <>
      <Helmet>
        <title>{t('psd2_verified:html_title')}</title>
      </Helmet>

      <div data-test="psd-result-card" className={styles.card}>
        <Typography className={styles.title} kind="h1" size="l">
          {t(`${psdResultMessageKey}.title`)}
        </Typography>
        <Typography className={styles.title} kind="p" size="s">
          {t(`${psdResultMessageKey}.subtitle`)}
        </Typography>
      </div>
    </>
  );
}
